import { create } from "zustand";

/**
 * Interface for the eleventEvent store state and actions
 */
export interface ElementEventState {
  // State properties
  selectedAction: string;
  selectedEvent: string;
  showEventForm: boolean;

  // Actions
  setSelectedAction: (value: string) => void;
  setSelectedEvent: (value: string) => void;
  setShowEventForm: (value: boolean) => void;
}

/**
 * Zustand store for eleventEvent
 */
export const useEleventEventStore = create<ElementEventState>()((set, get) => ({
  // Initial state
  selectedAction: "",
  selectedEvent: "",
  showEventForm: false,

  // Actions to update eleventEvent state
  setSelectedAction: (selectedAction: string) =>
    set({ selectedAction }),
  setSelectedEvent: (selectedEvent) =>
    set({
      selectedEvent,
    }),
  setShowEventForm: (showEventForm: boolean) =>
    set({
      showEventForm,
    }),
  getSelectedAction: () => {
    return get().selectedAction;
  },
  getSelectedEvent: () => {
    return get().selectedEvent;
  },
  getShowEventForm: () => {
    return get().showEventForm;
  },
}));
